import { render, staticRenderFns } from "./contact-card.vue?vue&type=template&id=0e1b3ae6"
import script from "./contact-card.vue?vue&type=script&lang=ts"
export * from "./contact-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconLogo: require('/vercel/path0/components/ui/icon/logo.vue').default,UiRating: require('/vercel/path0/components/ui/rating.vue').default,UiIconCheckGreen: require('/vercel/path0/components/ui/icon/check-green.vue').default,UiLink: require('/vercel/path0/components/ui/link.vue').default,UiIconWebwinkelkeur: require('/vercel/path0/components/ui/icon/webwinkelkeur.vue').default})
